"use strict";
/**
 * @param {object}   [entry={}]
 * @param {object}   [options={}]
 * @param {number}   [options.min=-Infinity] - Minimal unsaturation
 * @param {number}   [options.max=+Infinity] - Maximal unsaturation
 * @param {boolean}   [options.onlyInteger=false] - Integer unsaturation
 * @param {boolean}   [options.onlyNonInteger=false] - Non integer unsaturation
 * @return {boolean}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsaturationMatcher = unsaturationMatcher;
function unsaturationMatcher(entry, options = {}) {
    const { min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER, onlyInteger, onlyNonInteger, } = options;
    if (entry.unsaturation !== undefined) {
        if (entry.unsaturation < min || entry.unsaturation > max)
            return false;
        if (onlyInteger && !Number.isInteger(entry.unsaturation))
            return false;
        if (onlyNonInteger && Number.isInteger(entry.unsaturation))
            return false;
    }
    return true;
}
//# sourceMappingURL=unsaturationMatcher.js.map